import React from 'react'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'

import styles from './ClinicalProgress.module.sass'

const stateColors = [styles.state1Color, styles.state2Color, styles.state3Color]

const ClinicalProgress = (props) => {
	const { className, tint, state, displaySmall, ...attributes } = props
	const {
		progress = [],
		executed = {},
		currentState = [],
		stateLabel,
		labels = [],
	} = state || {}
	const { onHold, onGoing, executed: isExecuted } = executed || {}
	const backgroundColor =
		tint === 'light' ? 'rgba(255, 255, 255, 0.2)' : styles.borderColor
	const lineColor =
		tint === 'light' ? 'rgba(255, 255, 255, 0.4)' : styles.lineColor

	const dots = [
		{ cx: 4, filled: onHold, label: labels[0] },
		{ cx: 22, filled: onGoing, label: labels[1] },
		{ cx: 40, filled: isExecuted, label: labels[2] },
	]

	return displaySmall ? (
		<small className={styles['state-label']}>{stateLabel}</small>
	) : (
		<Tooltip text={stateLabel}>
			<svg {...attributes} viewBox='0 0 44 10' width='44' height='10'>
				<rect
					x='8'
					y='3'
					width='10'
					height='2'
					fill={progress[0] ? lineColor : backgroundColor}
				/>
				<rect
					x='26'
					y='3'
					width='10'
					height='2'
					fill={progress[1] ? lineColor : backgroundColor}
				/>
				{dots.map((dot, i) => (
					<g key={i}>
						<circle
							cx={dot.cx}
							cy='4'
							r='3.5'
							fill={dot.filled ? stateColors[i] : backgroundColor}
							stroke={
								dot.filled || currentState[i]
									? stateColors[i]
									: backgroundColor
							}
						/>
					</g>
				))}
				{!onHold && progress[0] ? (
					<rect x='0' y='3' width='8' height='2' fill={lineColor} />
				) : null}
				{!onGoing && progress[1] ? (
					<rect x='18' y='3' width='8' height='2' fill={lineColor} />
				) : null}
			</svg>
		</Tooltip>
	)
}
ClinicalProgress.displayName = 'ClinicalProgress'
export default ClinicalProgress
